import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FieldsInterventionsGridComponent} from './fields-interventions-grid.component';
import {FieldsInterventionsToolbarModule} from '../fields-interventions-toolbar/fields-interventions-toolbar.module';
import {TabModule} from '../../tab/tab.module';
import {DxButtonGroupModule, DxDataGridModule, DxPopoverModule} from 'devextreme-angular';
import {GridTitleModule, BadgeModule} from 'shared';
import {IconModule} from '@visurel/iconify-angular';
import {FieldsInterventionsReportModule} from '../fields-interventions-report/fields-interventions-report.module';
import {ReconstructedInterventionReportModule} from '../../reconstructed-interventions-grid/intervention-report/intervention-report.module';
import {DialogsModule} from '../../reconstructed-interventions-grid/dialogs.module';
import {DxSelectBoxModule, DxPopupModule, DxButtonModule, DxToolbarModule, DxFormModule, DxNumberBoxModule, DxDateBoxModule, DxScrollViewModule} from 'devextreme-angular';
import {RatingDialogComponent} from '../rating-dialog/rating-dialog.component';
import {ManualInterventionDialogComponent} from '../manual-intervention-dialog/manual-intervention-dialog.component';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {LeafletDrawModule} from '@asymmetrik/ngx-leaflet-draw';


@NgModule({
  declarations: [FieldsInterventionsGridComponent, RatingDialogComponent, ManualInterventionDialogComponent],
  imports: [
    CommonModule,
    FieldsInterventionsToolbarModule,
    TabModule,
    DxDataGridModule,
    GridTitleModule,
    BadgeModule,
    IconModule,
    DxPopoverModule,
    DxButtonGroupModule,
    FieldsInterventionsReportModule,
    ReconstructedInterventionReportModule,
    DialogsModule,
    DxSelectBoxModule,
    DxPopupModule,
    DxButtonModule,
    DxToolbarModule,
    DxFormModule,
    DxNumberBoxModule,
    DxDateBoxModule,
    DxScrollViewModule,
    LeafletModule,
    LeafletDrawModule
  ],
  exports: [FieldsInterventionsGridComponent]
})
export class FieldsInterventionsGridModule {
}
